import OverlayWindow, { WindowSize } from 'Components/OverlayWindow';
import { CheckboxInput } from 'Components/Auth/CheckboxInput';
import Button from 'Components/Buttons/Button';
import { FormProvider, useForm } from 'react-hook-form';
import { useClosePopup } from 'Components/Popups';

interface Props {
  onAgree: () => void;
}

export default function ServiceAgreementModal({ onAgree }: Props) {
  const close = useClosePopup();
  const methods = useForm<{ agree: boolean }>({
    defaultValues: { agree: false },
  });

  const handleSubmit = (data: { agree: boolean }) => {
    if (data.agree) {
      close();
      onAgree();
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        <OverlayWindow
          title="Service Agreement"
          size={WindowSize.md}
          onClose={close}
          body={
            <div className="space-y-2 text-sm text-gray-700">
              <p>
                <strong>I. Services</strong> In accordance with the terms and
                subject to the conditions set forth herein, AOA shall provide
                the services based upon the Client’s selection, which are listed
                on Schedule A (the “Services”). The Services will be conducted
                in accordance with GAAP and applicable U.S. federal and state
                tax laws and regulations.
              </p>
              <p>
                <strong>II. Term</strong> This Agreement shall govern the
                professional relationship from the Effective Date until
                termination pursuant to Section IV. Any amendments shall be
                attached hereto as part of this Agreement.
              </p>
              <p>
                <strong>III. Fees</strong> (a) The fee for Services, as
                indicated on the Statement of Work. (b) Late payment fees:
                Overdue 10 days: 10% of original balance. Overdue 11–20 days:
                additional 10% compounding (total 20%). Overdue 21–30 days:
                additional 10% compounding (total 30%).
              </p>
              <p>
                <strong>IV. Termination</strong> (a) By Client without cause,
                upon written notice to AOA’s Billing Department, provided no
                unpaid balance remains. (b) By AOA without cause, upon 30-day
                written notice. (c) For cause, as detailed in the body above
                (unpaid balances, breaches, etc.).
              </p>
              <p>
                <strong>V. Client’s Obligations</strong> The Client shall be
                solely responsible for providing all documents, data, and
                information necessary to perform the Services. Failure to supply
                requested information may constitute breach and may lead to
                termination.
              </p>
              <p>
                <strong>VI. AOA’s Obligations</strong> AOA shall perform the
                Services in a professional and workmanlike manner in accordance
                with GAAP and all applicable laws, and shall keep the Client
                reasonably informed of developments.
              </p>
              <p>
                <strong>VII. Independent Contractor</strong> The relationship is
                that of independent contractors. AOA shall not be deemed an
                employee, agent, or broker of the Client.
              </p>
              <p>
                <strong>VIII. Confidentiality</strong> AOA agrees to hold all
                Client Confidential Information in strict confidence and not
                disclose or use it except as necessary to perform the Services
                or as required by law.
              </p>
              <p>
                <strong>IX. Indemnification</strong> Each Party shall indemnify
                the other against all third-party claims, losses, and expenses
                arising from breach, negligence, or willful misconduct.
              </p>
              <p>
                <strong>X. Limitation of Liability</strong> Neither Party shall
                be liable for indirect or consequential damages; aggregate
                liability shall not exceed the amount paid by the Client under
                this Agreement.
              </p>
              <p>
                <strong>XI. General Provisions</strong> (a) Notices: in writing,
                delivered by email or certified mail. (b) Severability: invalid
                provisions shall be severable. (c) Successors &amp; Assigns: no
                assignment without written consent. (d) Non-Waiver: failure to
                enforce does not waive rights. (e) Amendment: only by written,
                signed amendment. (f) Entire Agreement: supersedes all prior
                agreements. (g) Governing Law: New York law. (h) Dispute
                Resolution: mediation, then binding AAA arbitration. (i)
                Counterparts: signed in counterparts.
              </p>
              <div className="pt-2">
                <CheckboxInput
                  name="agree"
                  label="I agree"
                  rules={{ required: 'required' }}
                  type="checkbox" // ✅ added required prop
                />
              </div>
            </div>
          }
          footer={
            <Button type="submit" theme="green-fill" className="w-full">
              Continue
            </Button>
          }
        />
      </form>
    </FormProvider>
  );
}
